import { Dispatch } from "redux";
import { IAction } from "../store";
import { FAILURE, REQUEST, SUCCESS } from "../../utils/actionsTypes";
import { Api } from "../../api";
import { ProdottoState } from "./prodotto.types";

export enum ProdottoActionType {
  LOAD = "prodotto/LOAD",
  CLEAR_ERROR = "prodotto/CLEAR_ERROR",
}

export const prodottoInitialState: ProdottoState = {
  data: undefined,
  id: "",
  loading: false,
  error: "",
};

export const prodottoReducer = (state: ProdottoState = prodottoInitialState, action: IAction): ProdottoState => {
  switch (action.type) {
    case REQUEST(ProdottoActionType.LOAD):
      return {
        ...state,
        id: action.payload,
        loading: true,
      };

    case SUCCESS(ProdottoActionType.LOAD):
      return {
        ...state,
        data: action.payload,
        loading: false,
      };

    case FAILURE(ProdottoActionType.LOAD):
      return {
        ...state,
        id: "",
        data: undefined,
        loading: false,
        error: action.payload,
      };

    case ProdottoActionType.CLEAR_ERROR:
      return {
        ...state,
        error: "",
      };

    default:
      return state;
  }
};

// Action creator

// Thunk
export const getProdotto =
  (id: string) =>
  (dispatch: Dispatch): void => {
    dispatch({ type: REQUEST(ProdottoActionType.LOAD), payload: id });
    Api.getProdotto(id)
      .then((data) => {
        dispatch({ type: SUCCESS(ProdottoActionType.LOAD), payload: data });
      })
      .catch((error) => {
        console.log("ERROR", error);
        dispatch({ type: FAILURE(ProdottoActionType.LOAD), payload: `${error}` });
      });
  };
